import React from 'react';

export class Footer extends React.Component {
  render() {
    return (
      <div className="footer">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <div className="copyright">
                <p>
                  © 2016-2019 iSlide Network Corporation. All rights reserved.
                </p>
              </div>
              <ul className="footer_social">
                <li>
                  <a href="https://twitter.com/iSlidePPT" target="_bank">
                    <i className="icon icon-twitter"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="https://www.youtube.com/channel/UCNEXhS4pUMqHigA7CEMRQFA"
                    target="_bank"
                  >
                    <i className="icon icon-youtube"></i>
                  </a>
                </li>
                <li>
                  <a href="https://www.facebook.com/iSlidePPT/" target="_bank">
                    <i className="icon icon-facebook"></i>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
